const WhyChoose = ({ style = "" }) => {
  const whyCooseContent = [
    {
      id: 1,
      icon: "https://image-prod.hubzu.com/about-us/capabilities.svg",
      title: "Capabilities",
      descriptions: `Technology to help you do it all - browse auctions, 
      place bids and more - anywhere, anytime.`,
    },
    {
      id: 2,
      icon: "https://image-prod.hubzu.com/about-us/transperency.svg",
      title: "Transparency",
      descriptions: `We provide a transparent process throughout the entire auction cycle in order to help ensure a fair auction process.`,
    },
    {
      id: 3,
      icon: "https://image-prod.hubzu.com/about-us/choices.svg",
      title: "Choices",
      descriptions: `Explore your options. Browse a broad range of properties to find your next investment.`,
    },
  ];

  return (
    <>
      {whyCooseContent.map((item) => (
        <div className="col-xs-12 col-sm-4" key={item.id}>
          <div className={`why_chose_us-about ${style}`}>
            
            <img alt={item.title} src={item.icon}/>
           
            <div className="details">
              <h2>{item.title}</h2>
              <p>{item.descriptions}</p>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default WhyChoose;
